import type { Job, JobReason } from '../api/types';
import { JOB_REASONS, jobDue, jobStatus, jobSubject, who } from '../lib/jobs';
import { Pill, Row } from './ui';

/** Řádek zakázky: číslo a zákazník, zařízení a závada, stav a termín (nebo proč hoří). */
export function JobRow({
  job,
  reason,
  onClick,
}: {
  job: Job;
  reason?: JobReason;
  onClick: () => void;
}) {
  const st = jobStatus(job.status);
  const due = jobDue(job);
  return (
    <Row onClick={onClick} className="job-row">
      <div className="grow">
        <div className="l1">
          {job.priority === 'high' && (
            <span className="job-hot" title="Spěchá">
              !
            </span>
          )}
          {job.number} · {job.customerName}
        </div>
        <div className="l2">
          {jobSubject(job)}
          {job.assignedEmail ? ` · ${who(job.assignedEmail)}` : ''}
        </div>
      </div>
      <div className="job-meta">
        <Pill kind={st.pill}>{st.short}</Pill>
        {reason ? (
          <span className="due-txt late">{JOB_REASONS[reason]}</span>
        ) : (
          due.text && <span className={`due-txt ${due.tone}`}>{due.text}</span>
        )}
      </div>
    </Row>
  );
}
